import React, { useCallback, useEffect, useRef, useState } from "react";
import { geocodeAddress } from "../utils/geocode";
import { Map, MapStyle, Marker, Popup, config } from "@maptiler/sdk";
import "@maptiler/sdk/dist/maptiler-sdk.css";
import places from "../data/places.json";
import useWindowSize from "../hooks/useWindowSize";

function MapIld() {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const markersRef = useRef([]);
  const isMobile = useWindowSize() <= 1024;

  const [mapLoaded, setMapLoaded] = useState(false);
  const [coordsList, setCoordsList] = useState([]);
  // console.log(coordsList);

  const lng = -77.30647299893094;
  const lat = 38.84603861038209;
  const zoom = isMobile ? 1.1 : 2;

  config.apiKey = process.env.REACT_APP_MAPAPIKEY;

  const createMarks = useCallback(() => {
    if (!map.current || coordsList.length === 0) return;
    markersRef.current.forEach((m) => m.remove());
    markersRef.current = [];

    let i = 0;
    coordsList.forEach(({ name, img, lat, lng, tag, index }) => {
      if (lat == null || lng == null) return;
      i += 1;
      const popupHTML = `
        <div style=" font-family: Montserrat; display:flex; flex-direction:column; gap:1rem; align-items:flex-start; width:350px; box-sizing:border-box">
          <h3 style="font-size:1.75rem; font-weight:900; color:#101823;">${name}</h3>
          <div style="display:flex; flex-direction: row; gap:1rem;">
            ${tag
                .split("-")
                .map(
                  (value) => `
                    <span style="
                      font-size:0.7rem;
                      padding:0.2rem 0.5rem;
                      outline-style:solid;
                      outline-color: #101823;
                      outline-width: 2px;
                      background-color: #ffffff;
                      color:#101823;
                      border-radius:10rem;
                      white-space:nowrap;
                    ">
                      ${value.trim()}
                    </span>
                  `,
                )
                .join("")}
            </div>
          <a  id="link-${i}" href="/projects#project-${i}" style ="padding: 0.5rem; background: #101823;color: #fbf3e6; font-weight: 900; font-size : 1rem; border-radius:0.25rem; ">Go to project</a>
        </div>
      `;
      const el = document.createElement("div");
      // el.style.backgroundImage = `url(${img})`;
      el.style.width = "50px";
      el.style.height = "50px";
      el.style.color = "#fbf3e6";
      el.style.display = "flex";
      el.style.alignItems = "center";
      el.style.justifyContent = "center";
      // el.style.backgroundSize = "80px ";
      el.style.backgroundColor = "#101823";
      // el.style.backgroundPosition = "top center";
      el.style.borderRadius = "50%";
      el.style.border = "3px solid #fbf3e6";
      el.style.fontSize = "1.25rem";
      el.style.fontWeight = "900";
      el.innerText = "ILD";
      // el.style.fontFamily = "Montserrat"
      el.style.fontFamily = "Hind";

      const marker = new Marker({
        element: el,
      })
        .setLngLat([lng, lat])
        .setPopup(
          new Popup({ offset: 40, anchor: isMobile ? "" : "left" })
            .setHTML(popupHTML)
            .setMaxWidth(isMobile ? "320px" : "450px"),
        )
        .addTo(map.current);

      markersRef.current.push(marker);
      marker.getElement().addEventListener("click", () => {
        map.current.flyTo({
          center: [
            marker.getLngLat().lng + (isMobile ? 0 : 0.001),
            marker.getLngLat().lat - (isMobile ? 0.002 : 0),
          ],
          zoom: 16,
          speed: 2,
        });
      });
    });
  }, [coordsList, isMobile]);

  // 1. Geocodificación
  useEffect(() => {
    async function fetchCoords() {
      try {
        const promises = places.map(async ({ place, img, name, tag }) => {
          const resultado = await geocodeAddress(place);

          return resultado
            ? { place, name, img, lat: resultado.lat, lng: resultado.lng, tag }
            : { place, name, img, lat: null, lng: null, tag };
        });

        const resultados = await Promise.all(promises);
        setCoordsList(resultados);
      } catch (error) {
        console.error("Error al obtener coordenadas", error);
      }
    }

    fetchCoords();
  }, [places]);

  // 2. Inicializar mapa + evento load
  useEffect(() => {
    if (map.current) return;

    map.current = new Map({
      container: mapContainer.current,
      style: MapStyle.BASIC.DEFAULT,
      center: [lng, lat],
      zoom,
      navigationControl: true,
      cooperativeGestures: true,
      projection: "globe",
      space: { color: "#030712" },
      halo: true,
      maptilerLogo: false,
    });

    map.current.on("load", () => {
      setMapLoaded(true);
    });
    return () => {
      markersRef.current.forEach((m) => m.remove());
      markersRef.current = [];

      if (map.current) {
        map.current.remove();
        map.current = null;
      }
    };
  }, [isMobile]);

  useEffect(() => {
    if (!mapLoaded || coordsList.length === 0) return;
    createMarks();
  }, [mapLoaded, coordsList, createMarks]);

  return (
    <div className="relative w-full h-[90vh] lg:h-[100dvh] overflow-hidden ">
      <div
        ref={mapContainer}
        className="absolute inset-0 w-full h-full lg:h-[110dvh] z-10"
      />
    </div>
  );
}

export default MapIld;
